(function() {
    'use strict'

    var pluginName = "menu";
    var defaults = {
    };

    // Plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);    // merge contents of objects into first object
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    // Plugin Methods
    Plugin.prototype = {
        init: function() {
            this.$element = $(this.element);
            this.$links = $('a[href*="#"]:not([href="#"])');

            this.bindEvents();
        },

        scrollToElement: function(e) {
            const element = e.currentTarget;

            if (location.pathname.replace(/^\//,'') == element.pathname.replace(/^\//,'') && location.hostname == element.hostname) {
                let target = $(element.hash);
                target = target.length ? target : $('[name=' + element.hash.slice(1) +']');

                if (element.hash !== '#menu') {
                    if (target.length) {
                        target.get(0).scrollIntoView({
                          block: 'start',
                          inline: 'nearest',
                          behavior: 'smooth',
                        });

                        window.setTimeout(() => {
                          document.querySelector('.js-header').classList.add('is-hidden');
                        }, 800);

                        if (window.history) {
                            history.pushState({}, "", "/" + element.hash);
                        }
                        return false;
                    }
                }
            }
        },

        // EVENTS
        bindEvents: function() {
            this.$links.on('click', this.scrollToElement.bind(this));
        }
    };

    // Plugin wrapper
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if(!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    }
}());
